import { createContext } from 'react';

import { UserAgentData } from './types';

export const UserAgentContext = createContext<UserAgentData>({ isAppWebView: false } as UserAgentData);
UserAgentContext.displayName = 'UserAgentContext';

export const UserAgentProvider = UserAgentContext.Provider;
